import { render } from "./BePartner.vue?vue&type=template&id=9aa9ae14&scoped=true"
import script from "./BePartner.vue?vue&type=script&lang=js"
export * from "./BePartner.vue?vue&type=script&lang=js"

import "./BePartner.vue?vue&type=style&index=0&id=9aa9ae14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa9ae14"]])

export default __exports__